import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { WagmiProvider } from 'wagmi'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit'
import { rainbowConfig, monadMainnet } from './config/rainbowkit'
import { ReconnectOnVisibility } from './ReconnectOnVisibility'
import { initSentry } from './utils/sentry'
import App from './App.jsx'
import './index.css'
import '@rainbow-me/rainbowkit/styles.css'

// Initialize Sentry error tracking (only if VITE_SENTRY_DSN is set in .env)
initSentry()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5_000, refetchOnWindowFocus: true },
  },
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <WagmiProvider config={rainbowConfig} reconnectOnMount>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          initialChain={monadMainnet}
          theme={darkTheme({
            accentColor: '#00f0ff',
            accentColorForeground: '#0a0e27',
            borderRadius: 'medium',
          })}
        >
          <ReconnectOnVisibility />
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>,
)